import { useBackendApi } from './backendApi';
import { useObjectDatesMapper } from './Helper';

export interface LlmTokenUsage {
  usedInputTokens: number;
  usedOutputTokens: number;
  totalUsed: number;
  periodStart: Date;
  periodEnd: Date;
  planId: string | null;
  limit: number;
  percentUsed: number;
  isLlmDebugEnabled: boolean;
}

function useLlmTokenUsageMapper() {
  return useObjectDatesMapper<LlmTokenUsage>([], ['periodStart', 'periodEnd']);
}

export function useLlmTokenUsageService() {
  const backendApi = useBackendApi();
  const mapper = useLlmTokenUsageMapper();

  const getUsage = async (): Promise<LlmTokenUsage> => {
    const response = await backendApi.get('/llm-chat/usage') as LlmTokenUsage;
    return mapper.mapSingle(response);
  };

  return {
    getUsage,
  };
}
